export default function lazyLoadImagesOnTable(table) {
  if (!table) return;

  const unloadedElems = [...table.querySelectorAll('img[data-src], iframe[data-src]')];
  unloadedElems.forEach((img) => {
    img.setAttribute('src', img.dataset.src);
  });
}
